/**
 * Option Type Constants
 */

export interface IOptionTypeOption {
  label: string;
  value: number;
}

export const ALL_OPTION_TYPES: IOptionTypeOption[] = [
  { label: "Deep Bottom Rail", value: 2 },
  { label: "Run-Through Horns", value: 3 },
  { label: "Dimension", value: 4 },
  { label: "Transom Drop", value: 5 },
  { label: "Sash", value: 7 },
  { label: "Hardware Colours", value: 9 },
  { label: "Spray", value: 10 },
  { label: "Spray Side", value: 11 },
  { label: "Inside Spray Colour", value: 12 },
  { label: "Outside Spray Colour", value: 13 },
  { label: "Cill Extension", value: 15 },
  { label: "Cill Horns", value: 16 },
  { label: "Welded Cill return", value: 17 },
  { label: "Hardware Item", value: 18 },
  { label: "Cill", value: 21 },
  { label: "Security", value: 22 },
  { label: "Bottom Sash", value: 23 },
  { label: "Top Sash", value: 24 },
  { label: "Place in Head", value: 26 },
  { label: "Place in Sash", value: 27 },
  { label: "Glass Specification", value: 28 },
  { label: "Space Bar", value: 29 },
  { label: "Glazing Pattern", value: 31 },
  { label: "External Colour", value: 34 },
  { label: "Internal Colour", value: 35 },
  { label: "Lead Top Sash", value: 36 },
  { label: "Lead Bottom Sash", value: 37 },
  { label: "Arch Top Sash", value: 38 },
  { label: "Arch Bottom Sash", value: 39 },
  { label: "Trickle Vents", value: 40 },
  { label: "Obscure Glazing", value: 41 },
  { label: "Obscure Glazing Placement", value: 42 },
  { label: "Head Extension", value: 44 },
  { label: "Left Jamb", value: 45 },
  { label: "Right Jamb", value: 46 },
  { label: "Weather Bar", value: 47 },
  { label: "Configuration Mode", value: 49 },
  { label: "Head Size", value: 50 },
  { label: "Left Jamb Size", value: 51 },
  { label: "Right Jamb Size", value: 52 },
  { label: "Cill Size", value: 53 },
  { label: "Head Quantity", value: 54 },
  { label: "Left Jamb Quantity", value: 55 },
  { label: "Right Jamb Quantity", value: 56 },
  { label: "Cill Quantity", value: 57 },
  { label: "Numeric Values", value: 58 },
  { label: "Custom Fraction", value: 59 },
  { label: "Profile Colour Type", value: 60 },
  { label: "Hardware Type", value: 61 },
  { label: "Glazing Type", value: 62 },
  { label: "Decorative Bar Type", value: 63 },
  { label: "Variation", value: 64 },
  { label: "D-Handle Position", value: 66 },
  { label: "Putty Line", value: 71 },
  { label: "Coupling Clip", value: 72 },
  { label: "Angled Cill Horn", value: 73 },
  { label: "Angled Cill Horn Size", value: 74 },
  { label: "Decorative Bar Note", value: 75 },
  { label: "Hardware Note", value: 76 },
  { label: "Cill Horn Size", value: 77 },
  { label: "Welded Cill Return Number", value: 78 },
  { label: "Vent Placement", value: 79 },
  { label: "Add-On Face", value: 80 },
  { label: "Glass Type", value: 81 },
  { label: "Add Ons", value: 82 },
  { label: "Size Inclusion", value: 83 },
  { label: "Fixing Lugs", value: 84 },
  { label: "Head Face", value: 85 },
  { label: "Cill Face", value: 86 },
  { label: "Left Jamb Face", value: 87 },
  { label: "Right Jamb Face", value: 88 },
  { label: "Fitting Type", value: 89 },
  { label: "Cill Note", value: 90 },
  { label: "Hardware Required", value: 91 },
  { label: "Egress Compliant", value: 48 },
  { label: "Top Sash Glazing Pattern", value: 92 },
  { label: "Bottom Sash Glazing Pattern", value: 93 },
  { label: "Timber Look Joints", value: 94 },
];
